<script setup lang="ts">
const isLoadingContent = ref(false);
const refers = ref<ITransactionResponse>({} as ITransactionResponse);

const refersData = computed(() => {
  const data = refers.value;

  return {
    data: data.data || [],
    total: data.total,
  };
});

async function getRefers() {
  const { ApiService } = useApiService();

  isLoadingContent.value = true;

  await ApiService.post('/users/list-referrals', {
    page: 1,
    type: 'all',
    date_period: 'all',
  }).then((response) => {
    refers.value = response.data;
    isLoadingContent.value = false;
  });
}

onBeforeMount(() => {
  getRefers();
});
</script>

<template>
  <UserBox class="text-white/60 bg-[#0A192A] px-4 rounded-xl">
    <BaseLoading
      class="!bg-auth-bg-primary !rounded-md !absolute"
      :icon-loader="true"
      :show="isLoadingContent"
    />

    <div class="text-[16px] text-white font-semibold mb-3 flex items-center">
      <NuxtIcon
        class="mr-3 text-[18px]"
        name="user/refers"
      />
      <p>Amigos Indicados</p>
    </div>

    <div v-if="isLoadingContent">
      <table class="wallet-table">
        <thead>
          <tr>
            <th class="px-2 py-3">
              <div class="row"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="i in 10"
            :key="i"
          >
            <td class="px-2 py-3">
              <div class="row"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-4 flex flex-col justify-center gap-3 md:flex-row md:justify-between md:items-center"
      >
        <p class="w-48 h-4 bg-bg-primary animate-pulse rounded-lg mx-auto"></p>
        <p
          class="w-11/12 h-9 bg-bg-primary animate-pulse rounded-lg md:w-3/5 mx-auto md:mr-0"
        ></p>
      </div>
    </div>

    <template v-else-if="refersData.data.length">
      <UserWalletTable
        :items="refersData.data"
        table-type="refers"
      />
    </template>

    <div
      v-else
      class="alert alert-warning text-sm"
    >
      {{ $t('refers.empty_message') }}
    </div>
  </UserBox>
</template>

<style scoped lang="scss">
.row {
  @apply bg-bg-primary animate-pulse h-5 rounded-md lg:h-6;
}
</style>
